// extracted by mini-css-extract-plugin
module.exports = {"showOnMobileOnly":"ShowOn_showOnMobileOnly__CSUdm","showOnDesktopOnly":"ShowOn_showOnDesktopOnly__M_N1U"};